
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 192 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M32 64a64 64 0 1164 64 64 64 0 01-64-64z","fill":"currentColor","opacity":".4"}}),_c('path',{attrs:{"d":"M48 144h11.36a87.91 87.91 0 0073.28 0H144a48 48 0 0148 48v136a24 24 0 01-24 24h-16v136a24 24 0 01-24 24H64a24 24 0 01-24-24V352H24a24 24 0 01-24-24V192a48 48 0 0148-48z","fill":"currentColor"}})])
          )
        }
      }
    